import Api from "@/services/apiService";

class expensesApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/expenses`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, expenseId) {
    return Api.getRequest(
      `companies/${companyId}/expenses/${expenseId}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, expenseData, isMultipart = false) {
    let headers = Api.authHeaders();

    if (isMultipart) {
      delete headers["Content-Type"];
    }

    return Api.postRequest(
      `companies/${companyId}/expenses`,
      expenseData,
      headers
    );
  }

  update(companyId, expenseId, expenseData, isMultipart = false) {
    let headers = Api.authHeaders();

    if (isMultipart) {
      delete headers["Content-Type"];
    }

    return Api.patchRequest(
      `companies/${companyId}/expenses/${expenseId}`,
      expenseData,
      headers
    );
  }

  accept(companyId, expenseId) {
    return Api.postRequest(
      `companies/${companyId}/expenses/${expenseId}/accept`,
      {},
      Api.authHeaders()
    );
  }

  export(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/expenses/export`,
      params,
      Api.authHeaders(),
      { responseType: "blob" } // важно для получения файла
    );
  }

  duplicate(companyId, id, params = {}) {
    return Api.postRequest(
      `companies/${companyId}/expenses/${id}/duplicate`,
      params,
      Api.authHeaders()
    );
  }

  delete(companyId, expenseId) {
    return Api.deleteRequest(
      `companies/${companyId}/expenses/${expenseId}`,
      Api.authHeaders()
    );
  }

  import(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/expenses/import`,
      data,
      Api.authHeaders()
    );
  }
}

export default new expensesApi();
